//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'
export default {
  name: 'index',
  data () {
    return {
      promoAdvantages: [{
        iconName: 'shuju1',
        iconSize: '12.5vw',
        iconPosition: '13%',
        iconLeft: '-9%',
        promoAdvanTitle: '数据分析 ',
        promoAdvanDescription: '旅游行业分析、竞品分析、本品分析、受众分析、 媒体数据分析;'
      }, {
        iconName: 'ico_yishenggongzuozhan_meilifangan',
        iconSize: '12.5vw',
        iconPosition: '14%',
        iconLeft: '-9%',
        promoAdvanTitle: '推广方案',
        promoAdvanDescription: '根据分析数据与传播目标，匹配最佳媒体投组合，规划传播策略与推广方案;'
      }, {
        iconName: 'koubei',
        iconSize: '11.5vw',
        iconPosition: '20%',
        iconLeft: '12%',
        promoAdvanTitle: '创意投放 ',
        promoAdvanDescription: '通过文案、海报、视频、话题营销等各种类型的传播方式，为品牌宣传;'
      }, {
        iconName: 'shuju',
        iconSize: '15.5vw',
        iconPosition: '-11%',
        iconLeft: '-30%',
        promoAdvanTitle: '数据检测',
        promoAdvanDescription: '根据推广情况监测各渠道数据效果，及时优化反馈;'
      }, {
        iconName: 'youhuayunhang',
        iconSize: '11.5vw',
        iconPosition: '8%',
        iconLeft: '6%',
        promoAdvanTitle: '实时优化',
        promoAdvanDescription: '专业运营团队全程跟进，实时优化推广方案， 以达到最佳传播效果;'
      }
      ],
      promoMethod: [{
        promoAdvanTitle: '社媒营销    ',
        promoAdvanDescription: '社媒覆盖，保持话题性，增强与受众的互动，有效增加粉丝黏性，完成数据转化;'
      }, {
        promoAdvanTitle: '口碑营销  ',
        promoAdvanDescription: '通过新闻稿件全网渠道扩散，树立品牌正面口碑，建立用户对品牌的信任;'
      }, {
        promoAdvanTitle: '红人推广   ',
        promoAdvanDescription: '利用网红效应，选取受众相符的网红大号对粉丝推荐引导，直接影响粉丝购买决策;'
      }, {
        promoAdvanTitle: '产品评测   ',
        promoAdvanDescription: '邀请母婴类媒体大号针对品牌特色产品进行测评，横向对比，突出优势；；'
      }, {
        promoAdvanTitle: '硬广投放   ',
        promoAdvanDescription: '基于用户习惯，有针对性的进行硬广投放，获取精准人群，权威网站硬广提升品牌信任；'
      }
      ]
    }
  },
  methods: {},
  components: {
    IndexHeader,
    IndexSidebar,
    IndexFooter
  }
}



// WEBPACK FOOTER //
// ./src/pages/solution/tourism/index.vue